import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import LandingPage from './pages/LandingPage';
import AuthPage from './pages/AuthPage';
import RegisterPage from './pages/RegisterPage';
import WelcomePage from './pages/WelcomePage';
import DailyEssentialsPage from './pages/DailyEssentialsPage';
import Dashboard from './pages/Dashboard';
import WeekView from './pages/WeekView';
import PaymentSuccess from './pages/PaymentSuccess';
import PricingPage from './pages/PricingPage';
import CommunityPage from './pages/CommunityPage';
import GalleryPage from './pages/GalleryPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import AccountSettingsPage from './pages/AccountSettingsPage';
import TestimonialAdminPage from './pages/TestimonialAdminPage';
import RegisterFreePage from './pages/RegisterFreePage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ArticlesPage from './pages/ArticlesPage';
import ArticlePage from './pages/ArticlePage';
import RecipesPage from './pages/RecipesPage';
import RecipePage from './pages/RecipePage';
// Guide Pages
import VeggieStirFryRecipe from './pages/VeggieStirFryRecipe';
import SmartGoalsGuide from './pages/guides/SmartGoalsGuide';
import MeditationGuide from './pages/guides/MeditationGuide';
import VisionBoardGuide from './pages/guides/VisionBoardGuide';
import MealPlanningGuide from './pages/guides/MealPlanningGuide';
import SkincareGuide from './pages/guides/SkincareGuide';
import MorningStretchGuide from './pages/guides/MorningStretchGuide';
import StyleDiscoveryGuide from './pages/guides/StyleDiscoveryGuide';
import StrengthTrainingGuide from './pages/guides/StrengthTrainingGuide';
import YogaGuide from './pages/guides/YogaGuide';
import WomensHealthGuide from './pages/guides/WomensHealthGuide';
import AffirmationsGuide from './pages/guides/AffirmationsGuide';
import GratitudeGuide from './pages/guides/GratitudeGuide';
import IntentionSettingGuide from './pages/guides/IntentionSettingGuide';
import WeeklyCelebrationGuide from './pages/guides/WeeklyCelebrationGuide';
import HydrationGuide from './pages/guides/HydrationGuide';
import MindfulShoppingGuide from './pages/guides/MindfulShoppingGuide';
import MindfulEatingGuide from './pages/guides/MindfulEatingGuide';
import NutritionDeepDiveGuide from './pages/guides/NutritionDeepDiveGuide';
import SkinAssessmentGuide from './pages/guides/SkinAssessmentGuide';
import MorningCleanseGuide from './pages/guides/MorningCleanseGuide';
import SPFGuide from './pages/guides/SPFGuide';
import EveningSkincareGuide from './pages/guides/EveningSkincareGuide';
import SpaMaskGuide from './pages/guides/SpaMaskGuide';
import NeckCareGuide from './pages/guides/NeckCareGuide';
import BeautySleepGuide from './pages/guides/BeautySleepGuide';
import MovementAssessmentGuide from './pages/guides/MovementAssessmentGuide';
import CardioGuide from './pages/guides/CardioGuide';
import StretchingGuide from './pages/guides/StretchingGuide';
import NatureWalkGuide from './pages/guides/NatureWalkGuide';
import ActiveRecoveryGuide from './pages/guides/ActiveRecoveryGuide';
import SleepEnvironmentGuide from './pages/guides/SleepEnvironmentGuide';
import SleepScheduleGuide from './pages/guides/SleepScheduleGuide';
import ScreenFreeEveningGuide from './pages/guides/ScreenFreeEveningGuide';
import BedtimeRitualGuide from './pages/guides/BedtimeRitualGuide';
import SleepSanctuaryGuide from './pages/guides/SleepSanctuaryGuide';
import CaffeineGuide from './pages/guides/CaffeineGuide';
import SleepMeditationGuide from './pages/guides/SleepMeditationGuide';
import StressInventoryGuide from './pages/guides/StressInventoryGuide';
import MorningCalmGuide from './pages/guides/MorningCalmGuide';
import BreathingTechniquesGuide from './pages/guides/BreathingTechniquesGuide';
import StressResponseGuide from './pages/guides/StressResponseGuide';
import NatureTherapyGuide from './pages/guides/NatureTherapyGuide';
import DigitalBoundariesGuide from './pages/guides/DigitalBoundariesGuide';
import SelfCompassionGuide from './pages/guides/SelfCompassionGuide';
import ConfidenceAssessmentGuide from './pages/guides/ConfidenceAssessmentGuide';
import PowerPostureGuide from './pages/guides/PowerPostureGuide';
import AcceptComplimentsGuide from './pages/guides/AcceptComplimentsGuide';
import ConfidenceOutfitGuide from './pages/guides/ConfidenceOutfitGuide';
import SelfLoveRitualGuide from './pages/guides/SelfLoveRitualGuide';
import CareerReflectionGuide from './pages/guides/CareerReflectionGuide';
import AlcoholAwarenessGuide from './pages/guides/AlcoholAwarenessGuide';
import SocialConnectionsGuide from './pages/guides/SocialConnectionsGuide';
import CreativeExpressionGuide from './pages/guides/CreativeExpressionGuide';
import MaintenancePlanGuide from './pages/guides/MaintenancePlanGuide';
// Week 8 Guides
import SkillsShowcaseGuide from './pages/guides/SkillsShowcaseGuide';
import CareerVisionGuide from './pages/guides/CareerVisionGuide';
import LearnSomethingNewGuide from './pages/guides/LearnSomethingNewGuide';
import ConnectionOutreachGuide from './pages/guides/ConnectionOutreachGuide';
import VoiceYourValueGuide from './pages/guides/VoiceYourValueGuide';
import WinCelebrationGuide from './pages/guides/WinCelebrationGuide';
// Week 9 Guides
import AlcoholFreeDayGuide from './pages/guides/AlcoholFreeDayGuide';
import MocktailMixologyGuide from './pages/guides/MocktailMixologyGuide';
import AlternativeUnwindingGuide from './pages/guides/AlternativeUnwindingGuide';
import SoberSocialGuide from './pages/guides/SoberSocialGuide';
import BodyAwarenessGuide from './pages/guides/BodyAwarenessGuide';
// Week 10 Guides
import SurpriseConnectionGuide from './pages/guides/SurpriseConnectionGuide';
import QualityTimeDateGuide from './pages/guides/QualityTimeDateGuide';
import GratitudeExpressionGuide from './pages/guides/GratitudeExpressionGuide';
import DeepListeningGuide from './pages/guides/DeepListeningGuide';
import CommunityConnectionGuide from './pages/guides/CommunityConnectionGuide';
import BoundaryPracticeGuide from './pages/guides/BoundaryPracticeGuide';
// Week 11 Guides
import VisualArtGuide from './pages/guides/VisualArtGuide';
import DancePartyGuide from './pages/guides/DancePartyGuide';
import CreativeWritingGuide from './pages/guides/CreativeWritingGuide';
import HandsOnCreatingGuide from './pages/guides/HandsOnCreatingGuide';
import PhotographyAdventureGuide from './pages/guides/PhotographyAdventureGuide';
import MusicalExpressionGuide from './pages/guides/MusicalExpressionGuide';
// Week 12 Guides
import VictoryCelebrationGuide from './pages/guides/VictoryCelebrationGuide';
import FutureVisionGuide from './pages/guides/FutureVisionGuide';
import HabitSelectionGuide from './pages/guides/HabitSelectionGuide';
import SupportNetworkGuide from './pages/guides/SupportNetworkGuide';
import CommitmentRitualGuide from './pages/guides/CommitmentRitualGuide';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/pricing" />;
}

// Redirect authenticated users away from public/auth pages to dashboard
function PublicRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? <Navigate to="/dashboard" /> : children;
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsAuthenticated(!!token);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth" element={<PublicRoute><AuthPage setIsAuthenticated={setIsAuthenticated} /></PublicRoute>} />
          <Route path="/register" element={<RegisterPage setIsAuthenticated={setIsAuthenticated} />} />
          <Route path="/register-free" element={<RegisterFreePage setIsAuthenticated={setIsAuthenticated} />} />
          <Route path="/forgot-password" element={<PublicRoute><ForgotPasswordPage /></PublicRoute>} />
          <Route path="/reset-password" element={<PublicRoute><ResetPasswordPage /></PublicRoute>} />
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/daily-essentials" element={<DailyEssentialsPage />} />
          <Route path="/pricing" element={<PublicRoute><PricingPage /></PublicRoute>} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
          <Route path="/articles" element={<ArticlesPage />} />
          <Route path="/articles/:slug" element={<ArticlePage />} />
          <Route path="/recipes" element={<RecipesPage />} />
          <Route path="/recipes/:slug" element={<RecipePage />} />
          <Route path="/account" element={<PrivateRoute><AccountSettingsPage /></PrivateRoute>} />
          <Route path="/admin/testimonials" element={<PrivateRoute><TestimonialAdminPage /></PrivateRoute>} />
          <Route path="/admin/dashboard" element={<PrivateRoute><AdminDashboardPage /></PrivateRoute>} />
          <Route path="/recipes/veggie-stir-fry" element={
            <PrivateRoute>
              <VeggieStirFryRecipe />
            </PrivateRoute>
          } />
          {/* Guide Routes */}
          <Route path="/guides/smart-goals" element={<PrivateRoute><SmartGoalsGuide /></PrivateRoute>} />
          <Route path="/guides/meditation" element={<PrivateRoute><MeditationGuide /></PrivateRoute>} />
          <Route path="/guides/vision-board" element={<PrivateRoute><VisionBoardGuide /></PrivateRoute>} />
          <Route path="/guides/meal-planning" element={<PrivateRoute><MealPlanningGuide /></PrivateRoute>} />
          <Route path="/guides/skincare" element={<PrivateRoute><SkincareGuide /></PrivateRoute>} />
          <Route path="/guides/morning-stretch" element={<PrivateRoute><MorningStretchGuide /></PrivateRoute>} />
          <Route path="/guides/style-discovery" element={<PrivateRoute><StyleDiscoveryGuide /></PrivateRoute>} />
          <Route path="/guides/strength-training" element={<PrivateRoute><StrengthTrainingGuide /></PrivateRoute>} />
          <Route path="/guides/yoga" element={<PrivateRoute><YogaGuide /></PrivateRoute>} />
          <Route path="/guides/womens-health-screenings" element={<PrivateRoute><WomensHealthGuide /></PrivateRoute>} />
          <Route path="/guides/affirmations" element={<PrivateRoute><AffirmationsGuide /></PrivateRoute>} />
          <Route path="/guides/gratitude" element={<PrivateRoute><GratitudeGuide /></PrivateRoute>} />
          <Route path="/guides/intention-setting" element={<PrivateRoute><IntentionSettingGuide /></PrivateRoute>} />
          <Route path="/guides/weekly-celebration" element={<PrivateRoute><WeeklyCelebrationGuide /></PrivateRoute>} />
          <Route path="/guides/hydration" element={<PrivateRoute><HydrationGuide /></PrivateRoute>} />
          <Route path="/guides/mindful-shopping" element={<PrivateRoute><MindfulShoppingGuide /></PrivateRoute>} />
          <Route path="/guides/mindful-eating" element={<PrivateRoute><MindfulEatingGuide /></PrivateRoute>} />
          <Route path="/guides/nutrition-deep-dive" element={<PrivateRoute><NutritionDeepDiveGuide /></PrivateRoute>} />
          <Route path="/guides/skin-assessment" element={<PrivateRoute><SkinAssessmentGuide /></PrivateRoute>} />
          <Route path="/guides/morning-cleanse" element={<PrivateRoute><MorningCleanseGuide /></PrivateRoute>} />
          <Route path="/guides/spf" element={<PrivateRoute><SPFGuide /></PrivateRoute>} />
          <Route path="/guides/evening-skincare" element={<PrivateRoute><EveningSkincareGuide /></PrivateRoute>} />
          <Route path="/guides/spa-mask" element={<PrivateRoute><SpaMaskGuide /></PrivateRoute>} />
          <Route path="/guides/neck-care" element={<PrivateRoute><NeckCareGuide /></PrivateRoute>} />
          <Route path="/guides/beauty-sleep" element={<PrivateRoute><BeautySleepGuide /></PrivateRoute>} />
          <Route path="/guides/movement-assessment" element={<PrivateRoute><MovementAssessmentGuide /></PrivateRoute>} />
          <Route path="/guides/cardio" element={<PrivateRoute><CardioGuide /></PrivateRoute>} />
          <Route path="/guides/stretching" element={<PrivateRoute><StretchingGuide /></PrivateRoute>} />
          <Route path="/guides/nature-walk" element={<PrivateRoute><NatureWalkGuide /></PrivateRoute>} />
          <Route path="/guides/active-recovery" element={<PrivateRoute><ActiveRecoveryGuide /></PrivateRoute>} />
          <Route path="/guides/sleep-environment" element={<PrivateRoute><SleepEnvironmentGuide /></PrivateRoute>} />
          <Route path="/guides/sleep-schedule" element={<PrivateRoute><SleepScheduleGuide /></PrivateRoute>} />
          <Route path="/guides/screen-free-evening" element={<PrivateRoute><ScreenFreeEveningGuide /></PrivateRoute>} />
          <Route path="/guides/bedtime-ritual" element={<PrivateRoute><BedtimeRitualGuide /></PrivateRoute>} />
          <Route path="/guides/sleep-sanctuary" element={<PrivateRoute><SleepSanctuaryGuide /></PrivateRoute>} />
          <Route path="/guides/caffeine" element={<PrivateRoute><CaffeineGuide /></PrivateRoute>} />
          <Route path="/guides/sleep-meditation" element={<PrivateRoute><SleepMeditationGuide /></PrivateRoute>} />
          <Route path="/guides/stress-inventory" element={<PrivateRoute><StressInventoryGuide /></PrivateRoute>} />
          <Route path="/guides/morning-calm" element={<PrivateRoute><MorningCalmGuide /></PrivateRoute>} />
          <Route path="/guides/breathing-techniques" element={<PrivateRoute><BreathingTechniquesGuide /></PrivateRoute>} />
          <Route path="/guides/stress-response" element={<PrivateRoute><StressResponseGuide /></PrivateRoute>} />
          <Route path="/guides/nature-therapy" element={<PrivateRoute><NatureTherapyGuide /></PrivateRoute>} />
          <Route path="/guides/digital-boundaries" element={<PrivateRoute><DigitalBoundariesGuide /></PrivateRoute>} />
          <Route path="/guides/self-compassion" element={<PrivateRoute><SelfCompassionGuide /></PrivateRoute>} />
          <Route path="/guides/confidence-assessment" element={<PrivateRoute><ConfidenceAssessmentGuide /></PrivateRoute>} />
          <Route path="/guides/power-posture" element={<PrivateRoute><PowerPostureGuide /></PrivateRoute>} />
          <Route path="/guides/accept-compliments" element={<PrivateRoute><AcceptComplimentsGuide /></PrivateRoute>} />
          <Route path="/guides/confidence-outfit" element={<PrivateRoute><ConfidenceOutfitGuide /></PrivateRoute>} />
          <Route path="/guides/self-love-ritual" element={<PrivateRoute><SelfLoveRitualGuide /></PrivateRoute>} />
          <Route path="/guides/career-reflection" element={<PrivateRoute><CareerReflectionGuide /></PrivateRoute>} />
          <Route path="/guides/alcohol-awareness" element={<PrivateRoute><AlcoholAwarenessGuide /></PrivateRoute>} />
          <Route path="/guides/social-connections" element={<PrivateRoute><SocialConnectionsGuide /></PrivateRoute>} />
          <Route path="/guides/creative-expression" element={<PrivateRoute><CreativeExpressionGuide /></PrivateRoute>} />
          <Route path="/guides/maintenance-plan" element={<PrivateRoute><MaintenancePlanGuide /></PrivateRoute>} />
          {/* Week 8 Guide Routes */}
          <Route path="/guides/skills-showcase" element={<PrivateRoute><SkillsShowcaseGuide /></PrivateRoute>} />
          <Route path="/guides/career-vision" element={<PrivateRoute><CareerVisionGuide /></PrivateRoute>} />
          <Route path="/guides/learn-something-new" element={<PrivateRoute><LearnSomethingNewGuide /></PrivateRoute>} />
          <Route path="/guides/connection-outreach" element={<PrivateRoute><ConnectionOutreachGuide /></PrivateRoute>} />
          <Route path="/guides/voice-your-value" element={<PrivateRoute><VoiceYourValueGuide /></PrivateRoute>} />
          <Route path="/guides/win-celebration" element={<PrivateRoute><WinCelebrationGuide /></PrivateRoute>} />
          {/* Week 9 Guide Routes */}
          <Route path="/guides/alcohol-free-day" element={<PrivateRoute><AlcoholFreeDayGuide /></PrivateRoute>} />
          <Route path="/guides/mocktail-mixology" element={<PrivateRoute><MocktailMixologyGuide /></PrivateRoute>} />
          <Route path="/guides/alternative-unwinding" element={<PrivateRoute><AlternativeUnwindingGuide /></PrivateRoute>} />
          <Route path="/guides/sober-social" element={<PrivateRoute><SoberSocialGuide /></PrivateRoute>} />
          <Route path="/guides/body-awareness" element={<PrivateRoute><BodyAwarenessGuide /></PrivateRoute>} />
          {/* Week 10 Guide Routes */}
          <Route path="/guides/surprise-connection" element={<PrivateRoute><SurpriseConnectionGuide /></PrivateRoute>} />
          <Route path="/guides/quality-time-date" element={<PrivateRoute><QualityTimeDateGuide /></PrivateRoute>} />
          <Route path="/guides/gratitude-expression" element={<PrivateRoute><GratitudeExpressionGuide /></PrivateRoute>} />
          <Route path="/guides/deep-listening" element={<PrivateRoute><DeepListeningGuide /></PrivateRoute>} />
          <Route path="/guides/community-connection" element={<PrivateRoute><CommunityConnectionGuide /></PrivateRoute>} />
          <Route path="/guides/boundary-practice" element={<PrivateRoute><BoundaryPracticeGuide /></PrivateRoute>} />
          {/* Week 11 Guide Routes */}
          <Route path="/guides/visual-art" element={<PrivateRoute><VisualArtGuide /></PrivateRoute>} />
          <Route path="/guides/dance-party" element={<PrivateRoute><DancePartyGuide /></PrivateRoute>} />
          <Route path="/guides/creative-writing" element={<PrivateRoute><CreativeWritingGuide /></PrivateRoute>} />
          <Route path="/guides/hands-on-creating" element={<PrivateRoute><HandsOnCreatingGuide /></PrivateRoute>} />
          <Route path="/guides/photography-adventure" element={<PrivateRoute><PhotographyAdventureGuide /></PrivateRoute>} />
          <Route path="/guides/musical-expression" element={<PrivateRoute><MusicalExpressionGuide /></PrivateRoute>} />
          {/* Week 12 Guide Routes */}
          <Route path="/guides/victory-celebration" element={<PrivateRoute><VictoryCelebrationGuide /></PrivateRoute>} />
          <Route path="/guides/future-vision" element={<PrivateRoute><FutureVisionGuide /></PrivateRoute>} />
          <Route path="/guides/habit-selection" element={<PrivateRoute><HabitSelectionGuide /></PrivateRoute>} />
          <Route path="/guides/support-network" element={<PrivateRoute><SupportNetworkGuide /></PrivateRoute>} />
          <Route path="/guides/commitment-ritual" element={<PrivateRoute><CommitmentRitualGuide /></PrivateRoute>} />
          <Route path="/community" element={
            <PrivateRoute>
              <CommunityPage />
            </PrivateRoute>
          } />
          <Route path="/gallery" element={
            <PrivateRoute>
              <GalleryPage />
            </PrivateRoute>
          } />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/week/:weekNumber"
            element={
              <PrivateRoute>
                <WeekView />
              </PrivateRoute>
            }
          />
          <Route
            path="/payment-success"
            element={
              <PrivateRoute>
                <PaymentSuccess />
              </PrivateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export { API };
export default App;